<ng-container *ngIf="this.event.type === eventType.ONLINE">
  <ng-container *ngIf="event.isEnabledStreaming && hasTicket else icon">
    <a [routerLink]="['/', 'event', event.name | slugify, event.id, 'stream']">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </a>
  </ng-container>
</ng-container>

<ng-template #icon>
  <span
    class="btn btn-error tooltip tooltip-{{ tooltipPosition }}"
    [class.has-ticket]="hasTicket" [class.btn-pulse]="event.isEnabledStreaming"
    [attr.data-tooltip]="tooltip | translate"
    (click)="checkTickets()">
    <material-icon>videocam</material-icon>
  </span>
</ng-template>
